export const LESSON_ITEM_STATUS = {
  EVALUATED: 'evaluated',
  DELIVERED: 'delivered',
  PENDING: 'pending',
};

export const LESSON_ITEM_PUBLISH_STATUS = {
  PUBLISHED: 'published',
  DRAFT: 'draft',
  SCHEDULED: 'scheduled',
};
